import { render, staticRenderFns } from "./Whcode.vue?vue&type=template&id=b094357a&"
import script from "./Whcode.vue?vue&type=script&lang=js&"
export * from "./Whcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports